export default {
  withdrawalPayment: {},
  withdrawalAmount: 0,
  cpsPaymentList: [],
}
